import { useAgentStore } from '@/agent/agentStore';
import { classifyAndRespond, randomFrom } from '@/agent/fakeBrain';
import { wait, randomBetween, newId } from '@/agent/utils';
import type { UIAction } from '@/agent/agentStore';
import { buildRecommendation } from '@/agent/recommendationBridge';

type ExecuteFn = (actions: UIAction[]) => Promise<void> | void;

export async function simulateAgentResponse(userMessage: string, executeActions: ExecuteFn) {
  const store = useAgentStore.getState();

  store.setTyping(true);
  await wait(randomBetween(400, 800));

  const response = classifyAndRespond(userMessage, store.memory);
  const replyText = typeof response.reply === 'string' ? response.reply : randomFrom(response.reply);

  const agentMessageId = newId();
  store.appendAgentMessage({
    id: agentMessageId,
    role: 'agent',
    content: '',
    status: 'streaming',
    timestamp: Date.now(),
  });

  // Word-by-word streaming
  const words = replyText.split(' ');
  let accumulated = '';
  for (const word of words) {
    accumulated += (accumulated ? ' ' : '') + word;
    useAgentStore.getState().updateAgentMessage(agentMessageId, { content: accumulated });
    await wait(randomBetween(30, 60));
  }

  const recommendation = buildRecommendation(response);
  useAgentStore.getState().updateAgentMessage(agentMessageId, {
    status: 'complete',
    uiActions: response.uiActions,
    widgets: response.widgets,
    recommendation,
  });

  if (response.memoryPatch) {
    useAgentStore.getState().updateMemory(response.memoryPatch);
  }

  await wait(400);
  if (response.uiActions && response.uiActions.length > 0) {
    await executeActions(response.uiActions);
  }

  useAgentStore.getState().setTyping(false);
}
